import { c as _c } from "react/compiler-runtime";
interface KMedicineClinicIconProps {
  size?: number;
  className?: string;
}
const KMedicineClinicIcon = t0 => {
  const $ = _c(11);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t10;
  let t11;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <rect x="6" y="9.25" width="17" height="4.25" rx="2.125" stroke="currentColor" strokeWidth="1.3" />;
    t7 = <rect x="6" y="13.5" width="17" height="4.25" rx="2.125" stroke="currentColor" strokeWidth="1.3" />;
    t8 = <rect x="6" y="17.75" width="17" height="4.25" rx="2.125" stroke="currentColor" strokeWidth="1.3" />;
    t9 = <path d="M14.5002 22L14.5002 9.25" stroke="currentColor" strokeWidth="1.3" />;
    t10 = <path d="M14.9066 8.86463C15.12 7.05668 16.5097 4.37721 17.9795 5.9012C19.4492 7.42518 16.8443 8.84464 14.9066 8.86463Z" stroke="currentColor" strokeWidth="1.3" />;
    t11 = <path d="M14.2315 8.86463C14.0182 7.05668 12.6284 4.37721 11.1587 5.9012C9.689 7.42518 12.2939 8.84464 14.2315 8.86463Z" stroke="currentColor" strokeWidth="1.3" />;
    $[2] = t10;
    $[3] = t11;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t10 = $[2];
    t11 = $[3];
    t6 = $[4];
    t7 = $[5];
    t8 = $[6];
    t9 = $[7];
  }
  let t12;
  if ($[8] !== t3 || $[9] !== t5) {
    t12 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}{t8}{t9}{t10}{t11}</svg>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  return t12;
};
export default KMedicineClinicIcon;